import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { ClipboardModule } from 'ngx-clipboard';

import { LinkRoutingModule } from './link-routing.module';
import { LinkListComponent } from './components/link-list.component';
import { LinkEditComponent } from './components/link-edit.component';
import { LinkStatisticComponent } from './components/link-statistic.component';
import { LinkService } from './link.service';

import { SharedModule } from '../shared/module';
import { StatisticModule } from '../statistics/statistic.module';

import { LinkErrorBlockComponent } from '../errors/error.component';

@NgModule({
  imports: [
    BrowserModule,
    SharedModule,
    ClipboardModule,
    StatisticModule,
    LinkRoutingModule,
  ],
  declarations: [
    LinkListComponent,
    LinkEditComponent,
    LinkStatisticComponent,
    LinkErrorBlockComponent
  ],
  exports: [
    LinkListComponent,
    LinkEditComponent,
    LinkStatisticComponent
  ],
  providers: [
    LinkService
  ]
})
export class LinkModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/links/link.module.ts